import React from 'react';
import classNames from "classnames";
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const EntityDescriptionModuleAsyncComponent = AsyncComponent(async () => import('./entity-description.module' /* webpackChunkName: "entity-description.module" */ ));

export const EntityDescriptionModuleAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<div className={classNames(props.className)}/>}>
      <EntityDescriptionModuleAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
